<template>
  <div>
    <other-banner :BannerType="'关于升和'"></other-banner>
    <div class="content_box">
      <div class="crumbs" ><span style="color: #666666">当前位置：关于升和></span> {{ $route.name }}</div>
      <div class="title" v-if="$route.meta.cate!='detais'">
        <title-nav :zhName="$route.name" :enName="$route.meta.cate"></title-nav>
      </div>
      <router-view/>
    </div>
  </div>

</template>

<script>
import OtherBanner from "../../components/otherBanner";
import TitleNav from "../../components/titleNav";
export default {
  name: "product",
  components: {TitleNav, OtherBanner},
  data(){
    return{

    }
  },

}
</script>

<style scoped lang="less">
.content_box{
  margin: 0 auto;
  cursor: pointer;
  .crumbs{
    width: 1200px;
    padding: 21px 0 15px;
    border-bottom: 1px solid #DBDBDB;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #0092DD;
    margin: 0 auto;
    opacity: 1;
  }
  .title{
    margin: 70px auto 47px;
  }
}
@media (max-width: 1200px) {
  .content_box{
    width: auto;
    //padding:0.1px 15px 0;
    .crumbs{
      width: auto;
      padding: 15px 0 7px;
      border-bottom: 1px solid #DBDBDB;
      font-size: 10px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #0092DD;
      opacity: 1;
    }
    .title{
      margin: 20px auto 15px;
    }
  }
}
</style>